import * as spn from "../operations/spans";
import * as sheets from "../sheets";
import group from "../operations/undo_group";

export function getSpan(row, column, page){
	if(!page || page == this.getActiveSheet())
		return this.$$("cells").getSpan(row, column);
	else{
		const sheet = sheets.getSheet(this, page);
		if(sheet && sheet.content.spans)
			return sheet.content.spans.find(span => span[0] <= row && span[1] <= column && span[0]+span[3] > row && span[1]+span[2] > column);
	}
}

export function combineCells(range, page, silent){
	const isActivePage = !page || page == this.getActiveSheet();
	if(!range){
		if(!isActivePage)
			return;
		if(Object.keys(this._table.getAllSelectAreas()).length !== 1)
			return;
		const sel = this.getSelectedId(true);
		if (sel.length>1){
			range = spn.getRange(sel);
		}
	}

	group.set(()=> {
		if (range)
			spn.addSpan(this, range.cell, range.x, range.y, null, page);
	});

	if(!silent && isActivePage)
		this.refresh();
}

export function splitCell(row, column, page, silent){
	const isActivePage = !page || page == this.getActiveSheet();

	if (row && column) {
		spn.removeSpan(this, {row, column}, page);
	}
	else if(isActivePage){
		group.set(function(){
			this.eachSelectedCell(function(cell){
				spn.removeSpan(this, cell);
			});
		},this);
	}

	if(!silent && isActivePage)
		this.refresh();
}